import { useMemo } from "react";
import { usePcpLiveLessonContext } from "../store";
import { isInteractiveWidgetSupported } from "../utils";

const SHORT_SCREEN_MAX_HEIGHT = 359; //px

export const useIsMobileWithSmallHeight = () => {
    const isMobile = usePcpLiveLessonContext(s => s.isMobile);
    const isWidgetSupported = isInteractiveWidgetSupported();
    const windowSize = usePcpLiveLessonContext(s => s.windowSize);
    const visibleViewportSize = usePcpLiveLessonContext(s => s.viewportSize);

    //getting visible viewport size:
    const viewportSize : {height: number | null} = isWidgetSupported ?
        windowSize  //use window 'resize' event (Android supported).
        : visibleViewportSize; //use visualViewport 'resize' event (iPhone supported).

    return useMemo(
        () => isMobile && viewportSize.height != null && viewportSize.height <= SHORT_SCREEN_MAX_HEIGHT,
        [viewportSize.height, isMobile]
    );
}
